import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { spacing, screen, container } from 'theme';
import BlogCard from '../cards/BlogCard';
import { getPostThumb, sortCategories } from '../utils/blogUtils';
import { WP_REST_API_Categories, WP_REST_API_Post } from 'wp-types';
import { getRelatedPosts } from 'services/wp.service';
import { useI18n } from 'hooks/useI18n';

const Container = styled.div`
  max-width: ${container('xl')};
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledBlogCards = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing('lg')};
  width: 100%;

  @media (min-width: ${screen('md')}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: ${screen('lg')}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

interface Props {
  currentPost: WP_REST_API_Post;
  categories: WP_REST_API_Categories;
  locale?: string;
}

export const RecommendedPosts: React.FC<Props> = ({
  currentPost,
  categories,
  locale
}) => {
  const { t } = useI18n('blog');
  const [recommended, setRecommended] = useState<WP_REST_API_Post[]>([]);

  const sortedCategories = useMemo(
    () => sortCategories(categories),
    [categories]
  );

  useEffect(() => {
    void (async () => {
      const related = await getRelatedPosts(currentPost, locale ?? 'en');
      setRecommended(related);
    })();
  }, [currentPost, locale]);

  if (!recommended.length) return null;

  return (
    <Container>
      <h2>{t('post.related')}</h2>
      <StyledBlogCards>
        {recommended.map((item) => (
          <BlogCard
            post={item}
            key={item.slug}
            title={item.title.rendered}
            url={item.slug}
            thumb={getPostThumb(item)}
            date={item.date}
          />
        ))}
      </StyledBlogCards>
    </Container>
  );
};
